import styled from 'styled-components';

// Dependencies
import { Link } from 'react-router-dom';

// Components
import { Typography } from '../../display/Typography';
import { MainButton } from '../../inputs/buttons/MainButton';
import InputText from '../../inputs/InputText';

export const ContainerForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const Title = styled(Typography)`
  font-size: 2.4rem;
  margin-bottom: 2.5rem;

  @media (max-width: 1024px) {
    font-size: 2.2rem;
    margin-bottom: 2.2rem;
  }
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  @media (max-width: 600px) {
    font-size: 1.8rem;
    margin-bottom: 1.8rem;
  }
  @media (max-width: 480px) {
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
  }
`;

export const Label = styled.label`
  margin-bottom: 0.5rem;
`;

export const TextInput = styled(InputText)`
  position: relative;
  margin-bottom: 2rem;
  > p {
    position: absolute;
    bottom: -2rem;
  }

  @media (max-width: 1024px) {
    margin-bottom: 1.8rem;
  }
  @media (max-width: 768px) {
    margin-bottom: 1.6rem;
  }
  @media (max-width: 600px) {
    margin-bottom: 1.5rem;
  }
  @media (max-width: 480px) {
    margin-bottom: 1.3rem;
  }
`;

export const InputTextPassword = styled(InputText)`
  position: relative;
  > p {
    position: absolute;
    bottom: -2rem;
  }
`;

export const ContainerLinkPassword = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const LinkPassword = styled(Link)`
  margin-top: 1.2rem;
  margin-bottom: 2rem;
  width: max-content;

  &:link {
    color: ${({ theme }) => theme.colors.black};
  }

  &:visited {
    color: ${({ theme }) => theme.colors.black};
  }

  @media (max-width: 1024px) {
    margin-top: 1rem;
    margin-bottom: 1.8rem;
  }
  @media (max-width: 768px) {
    margin-top: 0.8rem;
    margin-bottom: 1.5rem;
  }
  @media (max-width: 600px) {
    margin-top: 0.6rem;
    margin-bottom: 1.3rem;
  }
  @media (max-width: 480px) {
    margin-top: 0.5rem;
    margin-bottom: 1.2rem;
  }
`;

export const PrincipalButton = styled(MainButton)`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
  width: 100%;

  @media (max-width: 1024px) {
    margin-bottom: 1.8rem;
  }
  @media (max-width: 768px) {
    padding: 1.7rem;
    margin-bottom: 1.5rem;
  }
  @media (max-width: 600px) {
    margin-bottom: 1.2rem;
  }
  @media (max-width: 480px) {
    margin-bottom: 1rem;
  }
`;

export const LinkPolicy = styled(Link)`
  text-decoration: none;
`;

export const ContainerOra = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 2.5rem;

  @media (max-width: 1024px) {
    margin-bottom: 2rem;
  }
  @media (max-width: 768px) {
    margin-bottom: 1.8rem;
  }
  @media (max-width: 600px) {
    margin-bottom: 1.5rem;
  }
  @media (max-width: 480px) {
    margin-bottom: 1.2rem;
  }
`;

export const OraLogo = styled.img`
  width: 11rem;
  height: 3.236rem;

  @media (max-width: 1024px) {
    width: 10rem;
    height: 2.94rem;
  }
  @media (max-width: 768px) {
    width: 9rem;
    height: 2.65rem;
  }
  @media (max-width: 600px) {
    width: 8rem;
    height: 2.35rem;
  }
  @media (max-width: 480px) {
    width: 7rem;
    height: 2.06rem;
  }
`;

/**
 * Motivo por el que se cerró la sesión (spec 2026-10-01 § 5.4). Tarjeta blanca
 * como los demás avisos propios de la app, no una franja de color.
 */
